import React from 'react'
import {isUserInRegion} from '../services/auth'

const AccordionVendor = ({items, userRegion}) => {
    // let filteredItem = items.filter(item => isUserInRegion(item.region))

    let filteredItem = items.map(item => {
        if(item.vendors && isUserInRegion(userRegion, item.vendors.region)){
            return item.vendors
        }
    }).filter(x => x)

    return (
        <div className="row">

            {/* {console.log('---> accordion > vendor: ', items)} */}

            <h5>Approved Suppliers:</h5>

            {
                filteredItem &&
                filteredItem.map((vendor, i) => (
                    <div key={i} className="col-12 col-md-6 col-lg-4 mb-3">
                        
                        <div className="vendor-info">
                            {vendor.name && <strong><u>{vendor.name.toUpperCase() || ''}</u></strong>}

                            {(()=>{
                                // return vendor.services && <div>({vendor.services.split(',').join(', ')})</div>

                                let _services = vendor.services.split(',')
                                                                .map(item => {
                                                                    let splitName = item.split('__')
                                                                    let newName = item
                                                                    if(splitName[0] === 'Other'){
                                                                        newName = splitName[1]
                                                                    }
                                                                    return newName
                                                                })
                                                                .join(', ')

                                return vendor.services && <div>({_services})</div>
                            })()}

                            {(()=>{
                                let _address = ''
                                if(vendor.address){
                                    _address += vendor.address
                                }
                                if(vendor.city){
                                    _address += ' ' + vendor.city
                                }
                                if(vendor.address || vendor.city){
                                    _address += ','
                                }
                                if(vendor.province){
                                    _address += ' ' + vendor.province
                                }
                                if(vendor.postalCode){
                                    _address += ' ' + vendor.postalCode
                                }
                                return <div>{_address}</div>
                            })()}
                            {vendor.contact && <div>CONTACT: <span style={{color: 'rgb(167, 27, 0)'}}>{vendor.contact || ''}</span></div>}
                            {vendor.phoneNumber1 && <div>{vendor.phoneNumber1 || ''}</div>}
                            {vendor.phoneNumber2 && <div>{vendor.phoneNumber2 || ''}</div>}
                        </div>

                    </div>
                ))
            }

        </div>
    )
}

export default AccordionVendor